import React, { useState, useRef } from "react";
import {
  TextField,
  Button,
  Grid,
  CircularProgress,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import useAuth from "../utils/useAuth";
import { axiosWithoutHeader } from "../api/axios";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import InputLabel from "@mui/material/InputLabel";
import loader from "../utils/Helper";
import HandleOnBlurValiadtion from "../utils/validation";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from "@mui/material/Slide";
import "./Login.css";

const LOGIN_URL = "/account/adminLogin";
const validationRules = {
  username: {
    required: "Username is required",
   
  },
  password: {
    required: "Password is required",
   
  },

};

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

const AdminLoginContainer = () => {
const userNameRef=useRef()
  const passwordRef=useRef()
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const [severity, setSeverity] = React.useState(false);
  const [message, setMessage] = React.useState(false);
  const nativateto = location.state?.from?.pathname || "/dashboard";
  const initialValues = {
    username: "",
    password: "",
  };

  const validate = (values) => {
    const errors = {};

    if (!values.password) {
      errors.password = validationRules["password"].required;
    }
    if (!values.username) {
      errors.username = validationRules["username"].required;
    }

    return errors;
  };


  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      loader.isLoading(true);

      const response = await axiosWithoutHeader.post(LOGIN_URL, {
        username: values.username,
        password: values.password,
      });

      if (response.status === 200) {
        loader.isLoading(false);
        const jwtToken = response?.data?.jwtToken;
        const id = response?.data?.accountId;
        const firstName = response?.data?.firstName;
        const lastName = response?.data?.lastName;
        const isadmin = response?.data?.isAdmin;

        const userData = {
          id: response?.data?.userId,
          jwtToken: response?.data?.jwtToken,
          firstName: response?.data?.firstName,
          lastName: response?.data?.lastName,
          email: response?.data?.email,
          jwtExpiryToken: response?.data?.jwtExpiryToken,
          isAdmin: response?.data?.isAdmin,
          isSuperAdmin: response?.data?.isSuperAdmin,
          username: response?.data?.username,
          isProfileComplete:response?.data?.isProfileComplete
        };
        setAuth({ id, firstName, lastName, isadmin, jwtToken });
        formik.resetForm();
        localStorage.setItem("jwtToken", userData.jwtToken);
        localStorage.setItem("user", JSON.stringify(userData));
        navigate(nativateto, { replace: true });
      }
    } catch (err) {
      if (err.response?.data?.message?.includes("Password")) {
        passwordRef.current.focus();
      } else {
        userNameRef.current.focus();
      }

      setOpen(true);
      setSeverity('error');
      setMessage(err.response.data.message);

    } finally {
      setLoading(false);
      loader.isLoading(false);
    }
  };
  const formik = useFormik({
    initialValues: {
      ...initialValues,
      passwordRef,
      userNameRef,
    },
    onSubmit: handleSubmit,
    validate,
    validateOnBlur: true, // Disable onBlur validation
    validateOnChange: false, // Disable onChange validation
  });

  const [loading, setLoading] = useState(false);
  const [eyeSlash, setEyeSlash] = useState(false);

  const handleClose = async () => {
    setOpen(false);
  };

  return (

    <div className="bg-color">
      <Snackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        TransitionComponent={SlideTransition}
      >
        <Alert
          onClose={handleClose}
          severity= {severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <div class="page">
        <div class="brand">
          <img
            src="/newlogo.png"
            className="logoImage"
            alt="Logo"
          />
        </div>

        <section class="content">
          <div class="hero">
            <h1>
              Your Trusted Partner
              <br />
              in <span>Tax Solutions</span>
            </h1>

            <p>
              Our multidisciplinary team of experienced Chartered Accountants,
              Advocates, Lawyers and Company Secretaries provides comprehensive
              solutions.
            </p>

            <div class="features">
              <div class="feature">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="10" cy="7" r="4" />
                  <path d="M20 8v6" />
                  <path d="M23 11h-6" />
                </svg>
                Expert Team
              </div>

              <div class="feature">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect x="4" y="4" width="16" height="16" rx="2" />
                  <path d="M9 2v4" />
                  <path d="M15 2v4" />
                  <path d="M9 18v4" />
                  <path d="M15 18v4" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
                Reliable Platform
              </div>

              <div class="feature">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
                Secure Access
              </div>
            </div>

            <div class="illustration" aria-hidden="true">
              <img
                src="/illustration.png"
                width="475px"
                height="400px"
              />
            </div>
          </div>

          <div class="login-card">
            <h2>Welcome Admin</h2>

            <p class="subtitle">
              One-stop platform for comprehensive tax solutions
            </p>

             <form onSubmit={formik.handleSubmit}>
              {1 === 1 && (
                  <div class="input-wrap">
                     <TextField
                      id="username"
                      name="username"
                      label="Username"
                      fullWidth
                      // autoFocus
                      inputRef={userNameRef}
                      className="custom-inputField"
                      value={formik.values.username}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur("username")}
                      error={
                        formik.touched.username &&
                        Boolean(formik.errors.username)
                      }
                      helperText={
                        formik.touched.username && formik.errors.username
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />

                     <TextField
                      id="password"
                      name="password"
                      inputRef={passwordRef}
                      label="Password"
                      type={eyeSlash ? "text" : "password"}
                      fullWidth
                      style={{marginTop : "20px"}}
                      className="custom-inputField"
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur("password")}
                      error={
                        formik.touched.password &&
                        Boolean(formik.errors.password)
                      }
                      helperText={
                        formik.touched.password && formik.errors.password
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setEyeSlash(!eyeSlash)}
                              edge="end"
                            >
                              {eyeSlash ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                )}

              <button type="submit" class="otp-button">
                 {loading ? 
                 (
                    <CircularProgress
                      size={20}
                      style={{ marginRight: "5px" }}
                    />
                  ) : (
                    "Login"
                  )}
              </button>
            </form>
                
            {<Link className="forgot" to="/forgot-password">Forgot password?</Link>}     

          </div>
        </section>

        <div class="floating-ball" aria-hidden="true">
          <img
            src="/ball.png"
            width="150px"
            height="150px"
          />
        </div>
        <div class="sparkle" aria-hidden="true"></div>
      </div>
    </div>

  );
};

export default AdminLoginContainer;
